<template>
  <v-row no-gutters>
    <v-col>
      <v-card flat>
        <v-card-text class="d-flex flex-wrap px-3 pt-2 pb-0">
          <v-row>
            <v-col cols="auto" class="py-2 mt-1" align="center">
              <v-toolbar-title>{{ title }}</v-toolbar-title>
            </v-col>
            <v-divider vertical />
            <v-col class="py-2">
              <AddButton @click="redirect" />
            </v-col>
          </v-row>
          <v-col v-if="$slots.filters" cols="12" class="px-0 py-0">
            <slot name="filters" />
          </v-col>
        </v-card-text>
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
          :server-items-length="totalItems"
          :items-per-page="pagination.rowsPerPage"
          no-data-text="Даних немає"
          hide-default-footer
          class="elevation-1 mb-1"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td
                v-for="column in headers"
                :key="column.name"
                :style="
                  `${column.maxWwidth ? `max-width:${column.width}px;` : ''}`
                "
                class="px-2 text-left align-center document-blocks"
              >
                <component
                  :is="column.component"
                  v-if="column.component"
                  :value="item"
                  :style="
                    `${
                      column.maxWwidth ? `max-width:${column.width}px` : 'auto'
                    }`
                  "
                />
                <span v-else-if="column.type === 'date'">{{
                  item[column.name]
                    ? moment(item[column.name]).format("DD.MM.YY HH:mm")
                    : ""
                }}</span>
                <span v-else-if="column.type === 'object'">
                  {{ item[column.name] ? item[column.name].title : "" }}
                </span>
                <v-icon
                  v-else-if="column.type === 'action'"
                  @click="
                    $router.push({
                      path: `${addRoute.name}/${item.id}`,
                    })
                  "
                >
                  edit
                </v-icon>
                <v-menu
                  v-else-if="column.type === 'preview'"
                  open-on-hover
                  bottom
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      search
                    </v-icon>
                  </template>
                  <div class="block-preview" v-html="item[column.name]" />
                </v-menu>
                <router-link
                  v-else-if="column.type === 'route'"
                  :to="`${addRoute.name}/${item.id}`"
                >
                  {{ item[column.name] }}
                </router-link>
                <span v-else>{{ item[column.name] }}</span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <div class="text-center">
        <v-pagination
          v-model="pagination.page"
          :disabled="loading"
          :length="pages"
          :total-visible="10"
          color="red lighten-2"
        />
      </div>
    </v-col>
  </v-row>
</template>
<script>
import AddButton from "./AddButton.vue";
import * as listApi from "../backend/listApi.js";
import { createUrl } from "../helpers/urlQueryHelper.js";
import { saveDataListState } from "../helpers/dataListState.js";
import DocumentBlocksItem from "../views/document-blocks/DocumentsBlockItem.vue";

export default {
  components: {
    AddButton,
    DocumentBlocksItem,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    resource: {
      type: String,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
    addRoute: {
      type: Object,
      required: true,
    },
    filter: {
      type: [Object, String],
      default: () => {},
    },
    highBlock: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: false,
    items: [],
    totalItems: 0,
    pagination: {},
    pageSizeAtLink: "",
  }),
  computed: {
    pages() {
      if (this.pagination.rowsPerPage === null || this.totalItems === null) {
        return 0;
      }
      return Math.ceil(this.totalItems / this.pagination.rowsPerPage);
    },
    rowsCount() {
      let rows = null;
      if (this.highBlock) {
        rows = Math.floor((window.innerHeight - 300) / 200);
      } else {
        rows = Math.floor((window.innerHeight - 300) / 50);
      }
      return rows;
    },
    saveDataListState() {
      return saveDataListState;
    },
  },
  watch: {
    pagination: {
      handler() {
        this.getItems();
        if (
          this.pagination &&
          this.$router.currentRoute.query.page !== this.pagination.page
        ) {
          this.saveDataListState(
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.filter
          );
        }
      },
      deep: true,
    },
    filter: {
      handler() {
        this.pagination.page = 1;
        this.saveDataListState(
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.filter
        );
        this.getItems();
      },
      deep: true,
    },
  },
  created() {
    this.pageSizeAtLink = +this.$router.currentRoute.query.pageSize || 1;

    this.pagination = {
      page: +this.$router.currentRoute.query.page || 1,
      rowsPerPage: this.rowsCount,
    };
  },
  methods: {
    async getItems() {
      this.loading = true;

      const url = createUrl(
        this.pagination.page,
        this.pagination.rowsPerPage,
        this.filter,
        this.resource
      );
      const res = await listApi.getItems(url);
      this.items = res.result;
      this.totalItems = res.totalItems;
      this.loading = false;
    },
    redirect() {
      this.$router.push({
        path: `${this.addRoute.name}/0`,
      });
    },
  },
};
</script>

<style>
.block-preview {
  background: #fff;
  width: 1000px;
  max-height: 350px;
  overflow-x: hidden;
  padding: 20px;
}
.block-preview * {
  max-width: 100%;
  object-fit: contain;
}
</style>